{
  "settings": {
    "title": "Configuración de cuenta",
    "subtitle": "Gestiona tu correo electrónico, contraseña y estado de la cuenta.",
    "needHelp": "¿Necesitas ayuda? Únete a nuestro Discord"
  },
  "changeEmail": {
    "title": "Cambiar dirección de correo electrónico",
    "subtitle": "Cambiar tu correo requerirá que vuelvas a confirmar tu dirección de email. Se cerrará sesión en todos los dispositivos.",
    "newEmailLabel": "Nuevo correo electrónico",
    "newEmailPlaceholder": "Introduce el nuevo correo",
    "currentPasswordLabel": "Contraseña actual",
    "currentPasswordPlaceholder": "Introduce la contraseña actual",
    "submitButton": "Actualizar correo electrónico",
    "submittingButton": "Actualizando..."
  },
  "changePassword": {
    "title": "Cambiar contraseña",
    "subtitle": "Actualiza tu contraseña. Seguirás conectado en este dispositivo.",
    "currentPasswordLabel": "Contraseña actual",
    "currentPasswordPlaceholder": "Introduce la contraseña actual",
    "newPasswordLabel": "Nueva contraseña",
    "newPasswordPlaceholder": "Introduce la nueva contraseña",
    "confirmPasswordLabel": "Confirmar nueva contraseña",
    "confirmPasswordPlaceholder": "Confirma la nueva contraseña",
    "submitButton": "Cambiar contraseña",
    "submittingButton": "Actualizando..."
  },
  "closeAccount": {
    "title": "Cerrar cuenta",
    "subtitle": "Desactiva permanentemente tu cuenta. Si tienes una suscripción activa, será cancelada. Esta acción no puede deshacerse fácilmente.",
    "openButton": "Quiero cerrar mi cuenta",
    "warning": "⚠️ Advertencia: esto desactivará tu cuenta, cancelará cualquier suscripción activa, cerrará sesión en todos los dispositivos y no realizaremos reembolsos por suscripciones canceladas. Tus datos se conservarán pero tu cuenta será inaccesible.",
    "passwordLabel": "Tu contraseña",
    "passwordPlaceholder": "Introduce tu contraseña",
    "confirmLabel": "Escribe",
    "confirmCode": "CERRAR MI CUENTA",
    "confirmLabelEnd": "para confirmar",
    "confirmPlaceholder": "CERRAR MI CUENTA",
    "cancelButton": "Cancelar",
    "submitButton": "Cerrar cuenta permanentemente",
    "submittingButton": "Cerrando..."
  },
  "contactUs": {
    "title": "Contáctanos",
    "body": "Contáctanos en",
    "discordName": "Flipping Pal Discord",
    "bodyEnd": "o únete a nuestra comunidad de Discord para preguntas."
  }
}
